export const RANK_SYSTEM_LIST_REQUEST = 'RANK_SYSTEM_LIST_REQUEST';

export const RANK_SYSTEM_UPDATE_REQUEST = 'RANK_SYSTEM_UPDATE_REQUEST';
